import { css } from 'styled-components';
import {
  BreakpointQueryName, getSpacing, getTypography, SpacingName, ThemedFunctor, TypographyName,
} from '@doveit/lego';

const borderRadiusRem = 0.625;

export const base: ThemedFunctor = ({ theme }) => css`
  padding-top: ${borderRadiusRem * 2}rem;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: flex;
    padding: 0 ${borderRadiusRem}rem;
  }
`;

export const item: ThemedFunctor = ({
  theme,
  $isOpen,
  $overlappingIndex,
  $blockGrowthPercentage,
  $backgroundColor,
  $backgroundImage,
  $blockHeight,
}) => css`
    position: relative;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
    background-color: ${theme.palettes.neutrals.lighter};
    border-radius: ${borderRadiusRem}rem;
    margin-top: -${borderRadiusRem * 2}rem;
    padding-top: ${borderRadiusRem * 2}rem;
    z-index: ${$overlappingIndex};
    overflow: hidden;

    ${$isOpen && `
      background-color: ${$backgroundColor || theme.palettes.neutrals.lightest};

      ${$backgroundImage && `
        background-image: url(${$backgroundImage});
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
      `}
    `}

    &:first-child {
      padding-top: 0;
    }

    > * {
      &:first-child {
        ${getTypography(theme, TypographyName.H3)}
        ${getSpacing.padding(theme, SpacingName.SMALL)}
        color: ${theme.palettes.neutrals.medium};
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;

        ${$isOpen && `
          display: none;
        `}
      }

      &:last-child {
        will-change: opacity;
        opacity: 0;
        visibility: hidden;
        transition: opacity .15s ease .2s;
        height: 0;

        ${$isOpen && `
          opacity: 1;
          visibility: visible;
          height: auto;
        `}
      }
    }

    ${theme.breakpoints.up(BreakpointQueryName.MD)} {
      margin: 0 -${borderRadiusRem}rem;
      flex-grow: 1;
      height: ${$blockHeight};
      flex-basis: ${$blockGrowthPercentage}%;
      transition: flex ease-out .2s;
      will-change: flex-grow;
      padding-top: 0;

      > * {
        &:first-child {
          writing-mode: vertical-rl;
          height: 100%;
          text-align: center;
          left: 50%;
          position: relative;
          transform: translateX(-50%);
          display: block;

          ${$isOpen && `
            display: none;
          `}
        }

        &:last-child {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;

          ${$isOpen && `
            opacity: 1;
            visibility: visible;
          `}
        }
      }
    }
  `;
